<!--项目看板 -->
<template>
  <div class="information">
    <div class="table1">
      <div class="table-left">
        <div class="sum">
          <div>总人群数量</div>
          <div class="image">
            <img src="@/assets/images/analyse.png"
                 alt=""
                 class="img">
            <img src="@/assets/images/crowd.png"
                 alt=""
                 class="img2">
          </div>
        </div>
        <div class="number">51338</div>
        <div class="percentage">
          <div> <img src="@/assets/images/up.png"
                 alt=""
                 class="img"></div>
          <div class="text">较上月增长7.2%</div>
        </div>
      </div>
      <div class=" table-left table-right">
        <div class="sum">
          <div>项目总量</div>
          <div class="image">
            <img src="@/assets/images/analyse2.png"
                 alt=""
                 class="img">
            <img src="@/assets/images/user.png"
                 alt=""
                 class="img2">
          </div>
        </div>
        <div class="number">76</div>
        <div class="percentage">
          <div> <img src="@/assets/images/up.png"
                 alt=""
                 class="img"></div>
          <div class="text">较上月增长4.1%</div>
        </div>
      </div>
    </div>
    <!-- <div class="ProjectTop">
      <div class="managementItem">
        <div class="top">
          <div class="left">
            <div>管理项目</div>
            <div class="number">126</div>
          </div>
          <div class="right">
            <div class="image">
              <img src="../assets/images/folder.png"
                   style="width:50%">
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="result">
            <div class="number">32</div>
            <div>待上传</div>
          </div>
          <div class="result">
            <div class="number">45</div>
            <div>已上传</div>
          </div>
          <div class="result">
            <div class="number">28</div>
            <div>分析中</div>
          </div>
          <div class="result">
            <div class="number">21</div>
            <div>已分析</div>
          </div>
        </div>
      </div>
      <div class="ProjectVisit">
        <div class="top">
          <div class="left">
            <div>访问项目</div>
            <div class="number">84</div>
          </div>
          <div class="right">
            <div class="image">
              <img src="../assets/images/link.png"
                   style="width:50%">
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="result">
            <div class="number">35</div>
            <div>申请中</div>
          </div>
          <div class="result">
            <div class="number">49</div>
            <div>可访问</div>
          </div>

        </div>
      </div>
    </div> -->
    <!-- <el-card class="box-card">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="管理项目"
                     name="manage">
        </el-tab-pane>
        <el-tab-pane label="访问项目"
                     name="visit"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData"
                style="width: 100%">
        <el-table-column prop="name"
                         label="项目名称">
          <template slot-scope="scope">
            <i class="el-icon-folder"></i>
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date"
                         label="创建时间">
        </el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <el-tag>{{scope.row.status==1?'已分析':scope.row.status==2?'分析中':scope.row.status==3?'已上传':'待上传'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button-group>
              <el-button type="success"
                         size="mini"
                         icon="el-icon-view"></el-button>
              <el-button type="primary"
                         size="mini"
                         icon="el-icon-edit"></el-button>
              <el-button type="danger"
                         size="mini"
                         icon="el-icon-delete"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <template>
        <el-row class="pagination">
          <pagination :total="total"
                      :page.sync="queryParams.pageNum"
                      :limit.sync="queryParams.pageSize" />
        </el-row>
      </template>
    </el-card> -->
    <div class="table2">
      <el-card class="box-card"
               style="width: 50%; margin-right: 20px;">
        <div>
          <h1>年龄分布</h1>
          <div id="main"
               style="width: 100%; height: 600px;"></div>
        </div>
      </el-card>
      <el-card class="box-card"
               style="width: 50%; margin-right: 20px;">
        <div>
          <h1>性别分布</h1>

          <div id="main2"
               style="width: 100%; height: 600px;"></div>
        </div>
      </el-card>
    </div>
    <div class="table2">
      <el-card class="box-card"
               style="width: 50%; margin-right: 20px;">
        <div>
          <h1>疾病分布</h1>
          <div id="main3"
               style="width: 100%; height: 600px;"></div>
        </div>
      </el-card>
      <el-card class="box-card"
               style="width: 50%; margin-right: 20px;">
        <div>
          <h1>用户分布</h1>

          <div ref="mapRef"
               class="map-chart"
               style="width: 100%; height: 600px;"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// 引入echarts
import echarts from 'echarts'
import Pagination from '@/components/Pagination'
import chinaMap from 'echarts/map/json/china.json'
echarts.registerMap('china', chinaMap)
export default {
  components: {
    Pagination
  },
  props: {
    // 接收外部传入的人口数据
    populationData: {
      type: Array,
      default() {
        return [
          { name: '北京', value: 0 },
          { name: '天津', value: 0 },
          { name: '河北', value: 9987 },
          { name: '山西', value: 0 },
          { name: '内蒙古', value: 0 },
          { name: '辽宁', value: 0 },
          { name: '吉林', value: 0 },
          { name: '黑龙江', value: 0 },
          { name: '上海', value: 12767 },
          { name: '江苏', value: 14780 },
          { name: '浙江', value: 0 },
          { name: '安徽', value: 3027 },
          { name: '福建', value: 0 },
          { name: '江西', value: 425 },
          { name: '山东', value: 2837 },
          { name: '河南', value: 0 },
          { name: '湖北', value: 616 },
          { name: '湖南', value: 753 },
          { name: '广东', value: 0 },
          { name: '广西', value: 0 },
          { name: '海南', value: 0 },
          { name: '重庆', value: 0 },
          { name: '四川', value: 265 },
          { name: '贵州', value: 0 },
          { name: '云南', value: 0 },
          { name: '西藏', value: 0 },
          { name: '陕西', value: 2428 },
          { name: '甘肃', value: 0 },
          { name: '青海', value: 0 },
          { name: '宁夏', value: 0 },
          { name: '新疆', value: 0 },
          { name: '台湾', value: 0 },
          { name: '香港', value: 0 },
          { name: '澳门', value: 0 },
          { name: '南海诸岛', value: 0 }
        ]
      }
    }
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 126,
      tableData: [
        {
          date: '2025-05-02',
          name: '研究1',
          status: 1
        },
        {
          date: '2025-05-04',
          name: '研究2',
          status: 2
        },
        {
          date: '2025-05-01',
          name: '研究3',
          status: 3
        },
        {
          date: '2025-05-03',
          name: '研究4',
          status: 4
        }
      ],
      activeName: 'manage',
      config: {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15
      }
    }
  },
  mounted() {
    this.initChart()
    this.initChart2()
    this.initChart3()
    this.initChart4()
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById('main')
      const myChart = echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        // legend: {
        //   data: ['管理项目', '访问项目']
        // },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: ['5-10', '10-15', '15-20', '20-25', '25-30', '30-35', '35-40', '40-45', '45-50', '50-55', '55-60', '60-65', '65-70', '70-75', '75+']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}%' // 显示百分比
            }
          }
        ],
        series: [
          {
            name: '年龄分布',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            color: '#145fad',
            data: [0.5, 8.5, 12.2, 11.6, 10.6, 10.3, 8.6, 6.4, 5.6, 4.3, 5.2, 4.8, 4.3, 4.1, 3.0]
          }
        ]
      }

      myChart.setOption(option)
    },
    initChart2() {
      // 获取 DOM 元素
      var chartDom = document.getElementById('main2')
      var myChart = echarts.init(chartDom)

      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} :  {d}%'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20
        },
        series: [
          {
            name: '性别分布',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 52.7, name: '女性', itemStyle: { color: '#ed7310' } },
              { value: 47.3, name: '男性', itemStyle: { color: '#1b48ae' } }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{b}: {d}%' // 在饼图扇区上显示百分比
              }
            }
          }
        ]
      }
      // 设置图表的配置项
      myChart.setOption(option)
    },
    initChart3() {
      const chartDom = document.getElementById('main3')
      const myChart = echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        // legend: {
        //   data: ['管理项目', '访问项目']
        // },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: ['精神分裂症', '重度抑郁障碍', '双相情感障碍', '焦虑障碍', '脑卒中', '强迫障碍', '注意力多动缺陷障碍', '自闭症谱系障碍', '精神发育迟滞', '睡眠障碍'],
            axisLabel: {
              rotate: 25, // 旋转x轴标签
              fontSize: 10
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '疾病样本数',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            color: '#145fad',
            data: [4196, 2248, 1365, 1049, 911, 392, 366, 349, 235, 190]
          }
        ]
      }

      myChart.setOption(option)
    },
    initChart4() {
      // 销毁已存在的图表实例
      // if (this.chart) {
      //   this.chart.dispose()
      // }

      // 创建新图表实例
      this.chart = echarts.init(this.$refs.mapRef)

      // 计算数据中的最大值和最小值
      const values = this.populationData.map((item) => item.value)
      const maxValue = Math.max(...values)
      const minValue = Math.min(...values)

      // 配置图表选项
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // 如果人口为0，返回空字符串
            if (params.value === 0) {
              return ''
            }
            return `${params.name}: ${params.value} 人`
          }
        },
        visualMap: {
          type: 'continuous',
          min: minValue,
          max: maxValue,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          // calculable: true,
          color: ['#3c76b2', '#6378c0', '#697dc2', '#c5d4f5']
        },
        series: [
          {
            name: '人口分布',
            type: 'map',
            mapType: 'china',
            roam: true,
            label: {
              show: true,
              fontSize: 12
            },
            data: this.populationData
          }
        ]
      }

      // 设置图表选项
      this.chart.setOption(option)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang='scss' scoped>
.information {
  width: 100%;
  height: 100%;
  .table1 {
    display: flex;
    margin-bottom: 20px;
    .table-left {
      width: 50%;
      padding: 20px;
      background: linear-gradient(to right, #7ab6e3, #597793);
      border-radius: 10px;
      color: #fff;
      margin-right: 20px;
      .sum {
        display: flex;
        font-size: 20px;
        justify-content: space-between;
        .image {
          display: flex;
          .img {
            width: 20px;
            height: 20px;
          }
          .img2 {
            width: 20px;
            height: 20px;
            margin-left: 10px;
          }
        }
      }
      .number {
        font-weight: 600;
        font-size: 30px;
        margin-top: 20px;
      }
      .percentage {
        margin-top: 20px;
        display: flex;
        font-size: 15px;
        align-items: center;
        .img {
          width: 20px;
          height: 20px;
          .text {
            text-align: center;
          }
        }
      }
    }
    .table-right {
      background: linear-gradient(to right, #9d8464, #d38e41);
    }
  }
  .ProjectTop {
    display: flex;
    .managementItem {
      width: 50%;
      padding: 20px;
      background-color: #e2ebf4;
      border-radius: 10px;
      .top {
        display: flex;
        justify-content: space-between;
        .left {
          text-align: center;
          .number {
            margin-top: 4px;
            color: #256ab2;
            font-weight: 600;
          }
        }
        .image {
          width: 40px;
          height: 40px;
          background-color: #b7cde6;
          border-radius: 100%;
          display: flex; /* 激活 Flexbox 布局 */
          justify-content: center; /* 水平居中 */
          align-items: center;
        }
      }
      .bottom {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
        .result {
          .number {
            text-align: center;
            font-size: 600;
            color: #256ab2;
            margin-bottom: 4px;
          }
        }
      }
    }
    .ProjectVisit {
      margin-left: 30px;
      width: 50%;
      padding: 20px;
      border-radius: 10px;
      background-color: #f8f0e5;
      .top {
        display: flex;
        justify-content: space-between;
        .left {
          text-align: center;
          .number {
            margin-top: 4px;
            color: #f08a17;
            font-weight: 600;
          }
        }
        .image {
          width: 40px;
          height: 40px;
          background-color: #f6dabc;
          border-radius: 100%;
          display: flex; /* 激活 Flexbox 布局 */
          justify-content: center; /* 水平居中 */
          align-items: center;
        }
      }
      .bottom {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
        .result {
          .number {
            text-align: center;
            font-size: 600;
            color: #f08a17;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  .table2 {
    display: flex;
    justify-content: space-around;
  }
  .box-card {
    margin-bottom: 20px;
    border-radius: 10px;
  }
}
</style>